import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { SettingsMenuContainerSC } from 'containers/SettingsMenu'
import { FIXED_INDENTS, MEDIA } from 'vars/index'

export const SettingsPageContainerSC = styled.div<{
  maxWidth?: number
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '100%')};
  margin: var(${FIXED_INDENTS.INDENT_100}) auto 0 auto;

  ${MEDIA.MAX_1239} {
    padding: 0 var(${FIXED_INDENTS.INDENT_40});
    margin: var(${FIXED_INDENTS.INDENT_60}) auto 0 auto;
  }

  ${SettingsMenuContainerSC} {
    margin: var(${FIXED_INDENTS.INDENT_160}) 0 var(${FIXED_INDENTS.INDENT_80}) 0;

    ${MEDIA.MAX_1239} {
      margin: var(${FIXED_INDENTS.INDENT_120}) 0 var(${FIXED_INDENTS.INDENT_60})
        0;
    }

    ${MEDIA.MAX_599} {
      margin: var(${FIXED_INDENTS.INDENT_100}) 0 var(${FIXED_INDENTS.INDENT_50})
        0;
    }
  }

  & > ${ButtonSC} {
    width: fit-content;
    margin: 0 auto;
  }
`
